import Vue from "vue";
import { AmplifyEventBus } from "aws-amplify-vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // AUTHENTICATION
  {
    path: "",
    component: () =>
      import(/* webpackChunkName: "auth" */ "@/views/auth/Auth.vue"),
    children: [
      // { path: "/", redirect: { name: "signin" } },
      {
        path: "/",
        name: "validate",
        meta: {
          requiresAuth: false,
          title: "Aguarde..."
        },
        component: () =>
          import(
            /* webpackChunkName: "validate" */ "@/views/auth/pages/Validate.vue"
          )
      },
      {
        path: "/entrar",
        name: "signin",
        meta: {
          requiresAuth: false,
          title: "Entrar"
        },
        component: () =>
          import(
            /* webpackChunkName: "signin" */ "@/views/auth/pages/Signin.vue"
          )
      },
      {
        path: "/concluido",
        name: "done",
        meta: {
          requiresAuth: false,
          title: "Solicitação concluída"
        },
        component: () =>
          import(/* webpackChunkName: "done" */ "@/views/auth/pages/Done.vue")
      },
      {
        path: "/cadastro",
        name: "signup",
        meta: {
          requiresAuth: false,
          title: "Cadastrar"
        },
        component: () =>
          import(
            /* webpackChunkName: "signup" */ "@/views/auth/pages/Signup.vue"
          )
      },
      {
        path: "/recuperar-senha",
        name: "password-recovery",
        meta: {
          requiresAuth: false,
          title: "Recuperar senha"
        },
        component: () =>
          import(
            /* webpackChunkName: "recovery" */ "@/views/auth/pages/Recovery.vue"
          )
      },
      {
        path: "/redefinir-senha",
        name: "password-change",
        meta: {
          requiresAuth: false,
          title: "Redefinir senha"
        },
        component: () =>
          import(
            /* webpackChunkName: "password" */ "@/views/auth/pages/Password.vue"
          )
      },
      {
        path: "/obrigado",
        name: "email-sent",
        meta: {
          requiresAuth: false,
          title: "Confira seu e-mail"
        },
        component: () =>
          import(
            /* webpackChunkName: "emailsent" */ "@/views/auth/pages/EmailSent.vue"
          )
      },
      {
        path: "/sucesso",
        name: "success",
        meta: {
          requiresAuth: false,
          title: "Concluído"
        },
        component: () =>
          import(
            /* webpackChunkName: "success" */ "@/views/auth/pages/Success.vue"
          )
      }
    ]
  },
  // AUTHENTICATION

  // DASHBOARD
  {
    path: "/dashboard",
    component: () =>
      import(/* webpackChunkName: "dash" */ "@/views/dashboard/Dashboard.vue"),
    children: [
      {
        path: "/",
        name: "home",
        meta: {
          requiresAuth: true,
          title: "Página Inicial"
        },
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/dashboard/pages/Home.vue"
          )
      },
      {
        path: "auto",
        name: "autoLogin",
        meta: {
          requiresAuth: false,
          title: "Aguarde..."
        },
        component: () =>
          import(
            /* webpackChunkName: "auto" */ "@/views/dashboard/pages/Auto.vue"
          )
      },
      {
        path: "agencias",
        name: "agencies",
        meta: {
          requiresAuth: true,
          title: "Agências"
        },
        component: () =>
          import(
            /* webpackChunkName: "partners" */ "@/views/dashboard/pages/Partners.vue"
          )
      },
      {
        path: "anunciantes",
        name: "advertisers",
        meta: {
          requiresAuth: true,
          title: "Anunciantes"
        },
        component: () =>
          import(
            /* webpackChunkName: "partners" */ "@/views/dashboard/pages/Partners.vue"
          )
      },
      {
        path: "empresa",
        name: "company",
        meta: {
          requiresAuth: true,
          title: "Minha Empresa"
        },
        component: () =>
          import(
            /* webpackChunkName: "company" */ "@/views/dashboard/pages/Company.vue"
          )
      },
      {
        path: "nova-campanha",
        name: "new-campaign",
        meta: {
          requiresAuth: true,
          title: "Nova Campanha"
        },
        component: () =>
          import(
            /* webpackChunkName: "new-campaign" */ "@/views/dashboard/pages/NewCampaign.vue"
          )
      },
      {
        path: "editar-campanha/:campaignId",
        name: "edit-campaign",
        meta: {
          requiresAuth: true,
          title: "Editar Campanha"
        },
        component: () =>
          import(
            /* webpackChunkName: "new-campaign" */ "@/views/dashboard/pages/NewCampaign.vue"
          )
      },
      {
        path: "campanhas",
        name: "campaigns",
        meta: {
          requiresAuth: true,
          title: "Campanhas"
        },
        component: () =>
          import(
            /* webpackChunkName: "home" */ "@/views/dashboard/pages/Home.vue"
          )
      },
      {
        path: "campanha/:campaignId",
        name: "campaign",
        meta: {
          requiresAuth: true,
          title: "Campanha"
        },
        component: () =>
          import(
            /* webpackChunkName: "campaign" */ "@/views/dashboard/pages/Campaign.vue"
          )
      },
      {
        path: "ajuda",
        name: "help",
        meta: {
          requiresAuth: true,
          title: "Ajuda"
        },
        component: () =>
          import(
            /* webpackChunkName: "help" */ "@/views/dashboard/pages/Help.vue"
          )
      },
      {
        path: "usuarios",
        name: "users",
        meta: {
          requiresAuth: true,
          title: "Usuários"
        },
        component: () =>
          import(
            /* webpackChunkName: "users" */ "@/views/dashboard/pages/Users.vue"
          )
      },
      {
        path: "sair",
        name: "logout",
        meta: {
          requiresAuth: true,
          title: "Sair"
        },
        component: () =>
          import(
            /* webpackChunkName: "logout" */ "@/views/dashboard/pages/Logout.vue"
          )
      }
    ]
  }
  // DASHBOARD
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve(async (to, _, next) => {
  if (to.matched.some(record => record.meta && record.meta.requiresAuth)) {
    try {
      // Check if user is authenticated
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
      next();
    } catch (err) {
      // Redirect user to login page
      next({
        name: "signin",
        query: {
          redirect: to.fullPath
        }
      });
    }
  }

  next();
});

AmplifyEventBus.$on("authState", (eventInfo: string) => {
  if (eventInfo === "signedIn") {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    const redirect = params.get("redirect");
    if (redirect) {
      return router.push({ path: redirect });
    }

    router.push({ name: "home" });
  } else if (eventInfo === "signedOut") {
    router.push({ name: "signin" });
  }
});

export default router;
